/** Product name shown in UI, document title, and alt text. */
export const APP_DISPLAY_NAME = "Dataly Cloud Secret Manager";

export const APP_SHORT_ORG = "Dataly Cloud";

/** Optional swap: replace `public/dataly-cloud-logo.png` with `dataly-cloud-logo-alt.png` (simpler flat mark). */
